import type { AgentSkill } from "./types";

export const appNavigationSkill: AgentSkill = {
	name: "app-navigation",
	description:
		"Read the current page and open Home, Library, whiteboards, trash, draft, profile, a board, or a card. Use before answering about the route or navigating the app.",
	body: [
		"App navigation: call getCurrentRoute when you need to know which page the user is on (pathname + parsed route). Do not assume the route without reading it. Use navigateApp to open Home, Library, Whiteboards list, Trash, Draft, Profile, a whiteboard (destination whiteboard + whiteboardId), or a card page (destination card + cardId). Never navigate outside the authenticated app.",
		"App navigateApp changes the SPA page. Board navigateToCard / navigateToShape only pan/zoom the canvas camera — they are not app routing. After createWhiteboard, call navigateApp only if the user asked to open or go to that board. Leaving a whiteboard unregisters board tools for later turns — finish canvas work before navigating away, or navigate back to reopen them.",
	].join("\n"),
	surface: "app",
};
